module.exports = __webpack_public_path__ + "img/iva_vendido.f13b6e55.png";